/**
 * GoszakupPortalPage — изолированная страница для роли goszakup
 * Показывает ТОЛЬКО кнопку перехода на Procurement Intel (Agent Server)
 * Нет доступа к остальным функциям PCC
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ExternalLink, LogOut, Search } from 'lucide-react';

const PROCUREMENT_INTEL_URL = 'https://ru-karporat.dalartservice.com/procurement-intel/dashboard';

const GoszakupPortalPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleOpenProcurementIntel = () => {
    window.open(PROCUREMENT_INTEL_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="text-lg font-semibold text-gray-800">PCC</span>
              <span className="text-sm text-gray-400">|</span>
              <span className="text-sm text-gray-600">{user?.full_name || user?.email}</span>
              <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded">
                Госзакупки
              </span>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={handleLogout}
              className="text-red-600 border-red-200 hover:bg-red-50 hover:border-red-300"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Выйти
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex items-center justify-center" style={{ minHeight: 'calc(100vh - 73px)' }}>
        <Card className="w-full max-w-md mx-4 shadow-lg">
          <CardContent className="p-8 text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Search className="w-8 h-8 text-blue-600" />
            </div>

            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Procurement Intel
            </h1>
            <p className="text-gray-600 mb-6">
              Поиск и анализ государственных закупок
            </p>

            <Button
              size="lg"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-6 text-lg"
              onClick={handleOpenProcurementIntel}
            >
              <ExternalLink className="w-5 h-5 mr-2" />
              Открыть портал закупок
            </Button>

            <p className="text-xs text-gray-400 mt-4">
              Откроется в новой вкладке
            </p>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default GoszakupPortalPage;
